import React, { useState, ChangeEvent, FormEvent } from 'react';
import '../Styles/SearchBar.css';

interface Props {
    onSearch: (query: string) => void;
}

export default function SearchBar({ onSearch }: Props) {
    const [query, setQuery] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setQuery(event.target.value);
    };

    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setLoading(true);
        await onSearch(query);
        setLoading(false);
    };

    return (
        <form onSubmit={handleSubmit}>
            <input
                className={"searchBar"}
                type="text"
                placeholder="Rechercher..."
                value={query}
                onChange={handleChange}
            />
            <button type="submit" disabled={loading}>
                {loading ? 'Recherche en cours...' : 'Rechercher'}
            </button>
        </form>
    );
}
